module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page about",
    class: {
      init: _vm.isInit
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row center-xs last"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "scroll-btn"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 477.175 477.175"
    },
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 477.175 477.175",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12 text-center first"
  }, [_c('h1', [_vm._v("Thank You !")]), _vm._v(" "), _c('p', [_vm._v("You've reached the end...of this request, but we know this is just the beginning of all the awesome ideas that are coming your way! \r\n        🦹🏻‍♂️Thank you for taking the time to visit our website and for your trust in sharing all our personal details with us 🦹🏻‍♂️\r\n        We're not the spamming kind, but we do like sending information that will help you in your business growth, digitally. \r\n        Our team of digital natives will contact you shortly to understand your requirements and guide you to the next steps. \r\n        Hold on tight & Have a space day! ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-xs contact-btn"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-12 text-center"
  }, [_c('a', {
    staticClass: "next",
    attrs: {
      "href": "tel:'919833390023'"
    }
  }, [_c('span', [_vm._v("Call Now")])]), _vm._v(" "), _c('span', {
    staticClass: "line"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1df91fe8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThankYou.vue
// module id = 155
// module chunks = 0